<template>
<div class="details">
  <div class="details-main" >
    <div class="details-main-header">
      <el-descriptions :column="3" border direction="horizontal" size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'calc(20% - 120px)'}">
        <el-descriptions-item label="公司名称">{{from_data.company_name}}</el-descriptions-item>
        <el-descriptions-item label="项目名称">{{from_data.project_name}}</el-descriptions-item>
        <el-descriptions-item label="催缴类型">{{urgeTypeToText(from_data.urge_type)}}</el-descriptions-item>

        <el-descriptions-item label="开始时间">{{from_data.start_time}}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{from_data.end_time}}</el-descriptions-item>
        <el-descriptions-item label="--">--</el-descriptions-item>

        <el-descriptions-item label="房屋数量">{{from_data.house_count}}</el-descriptions-item>
        <el-descriptions-item label="房屋金额">{{(from_data.house_money||0)}}</el-descriptions-item>
        <el-descriptions-item label="--">--</el-descriptions-item>

        <el-descriptions-item label="催缴次数">{{from_data.collection_num}}</el-descriptions-item>
        <el-descriptions-item label="催缴户数">{{from_data.collection_house_num}}</el-descriptions-item>
        <el-descriptions-item label="催缴率">{{from_data.collection_house_rate}}</el-descriptions-item>

        <el-descriptions-item label="回款户数">{{from_data.payment_collection_num}}</el-descriptions-item>
        <el-descriptions-item label="回款金额">{{(from_data.payment_collection_amount||0)}}</el-descriptions-item>
        <el-descriptions-item label="回款率">{{from_data.payment_collection_rate}}</el-descriptions-item>

        <el-descriptions-item label="服务费率">
          <el-input v-model="from_data.service_rate" size="mini" @input="computeMoney" style="width: 200px;" disabled></el-input><br />
          <span style="color: #ff3d00">取数范围0-100，默认为0，填写20表示20%</span>
        </el-descriptions-item>
        <el-descriptions-item label="系统计费">
          <el-input v-model="from_data.money" size="mini" style="width: 200px;" disabled></el-input>
          <span style="color: #ff3d00">单位为元</span>
        </el-descriptions-item>
        <el-descriptions-item label="服务费">
          <el-input v-model="from_data.paid_money" size="mini" style="width: 200px;" :disabled="from_data.status===3"></el-input>
          <span style="color: #ff3d00">单位为元</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="details-main-body">
      <ThirdPartyCompanyProjectMonthDetailsList
        v-if="year_month"
        :project-id="from_data.project_id"
        :urge-type="from_data.urge_type"
        :start-time="startTime"
        :end-time="endTime"
      />
    </div>
  </div>
</div>
</template>

<script>
import ThirdPartyCompanyProjectMonthDetailsList from "./ThirdPartyCompanyProjectMonthDetailsList";
import moment from "moment";
import ButlerHttp from "../../common/ButlerHttp";
export default {
  name: "ThirdPartyCompanyProjectMonthDetails",
  components: {ThirdPartyCompanyProjectMonthDetailsList},
  props:{
    yearMonth:{
      type: String,
      default: ""
    },
    fromData:{
      type: Object,
      default: () => {
        return {}
      }
    },

  },
  data() {
    return {
      year_month:"",
      from_data: {},
    }
  },
  mounted() {
    this.year_month = this.yearMonth;
    this.from_data = JSON.parse(JSON.stringify(this.fromData));
    this.getServiceRate();
  },
  methods: {
    urgeTypeToText(val) {
      switch (val) {
        case 1: return "自催";
        case 2: return "诉讼";
        case 3: return "第三方管理";
        case 4: return "第三方诉讼";
        case 5: return "项目自催";
        default: return "--";
      }
    },
    computeMoney(val){
      this.from_data.money = Math.round(this.from_data.payment_collection_amount * (this.from_data.service_rate / 100)*100)/100;
      this.from_data.paid_money = Math.round(this.from_data.payment_collection_amount * (this.from_data.service_rate / 100)*100)/100;
    },
    submit(){
      const that = this;

      ButlerHttp.post("ThirdPartyCommon/saveProjectCompanyMonthMoney", {
        id: this.from_data.cps_id,
        service_rate: this.from_data.service_rate,
        money: this.from_data.money,
        paid_money: this.from_data.paid_money
      }, res => {
        if (res.code) {
          that.$message.success("保存成功");
          that.$emit("onSubmit");
        }else {
          that.$message.error(res.msg);
        }
      });
    },
    getServiceRate(){
      const that = this;
      if(that.from_data.service_rate>0){
        return;
      }
      ButlerHttp.post("ProjectCollectionThridCompanyProjectContract/getServiceRate", {
        project_id: that.from_data.project_id,
        company_id: that.from_data.company_id,
        urge_type: that.from_data.urge_type,
      }, res => {
        if (res.code) {
          that.from_data.service_rate = res.data||0;
          that.computeMoney();
        }
      });
    }
  },
  computed:{
    startTime() {
      return moment(this.year_month+"-01").format("YYYY-MM-DD")
    },
    endTime() {
      return moment(this.year_month+"-01").add(1, 'months').subtract(1, 'days').format("YYYY-MM-DD")
    }
  }
}
</script>

<style lang="scss" scoped>
.details{
  >>> .el-dialog__body{
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectMonthDetails.vue